// Login
export const LOGIN = 'LOGIN';
export const USERNAME = 'USERNAME';
export const PASSWORD = 'PASSWORD';
export const ERROR = 'ERROR';

// Logout
export const LOGOUT = 'LOGOUT';
